import { createAction, createAsyncAction } from 'typesafe-actions';
import { Actions, CompareLists } from '../types';

export const SEND_PRODUCTS_COMPARE_LIST_ACTION = createAction('ui/SEND_PRODUCTS_COMPARE_LISTS_ACTION')<{
  action: Actions;
}>();

export const PRODUCTS_COMPARE_LISTS = createAsyncAction(
  'productsCompare/PRODUCTS_COMPARE_LISTS/request',
  'productsCompare/PRODUCTS_COMPARE_LISTS/success',
  'productsCompare/PRODUCTS_COMPARE_LISTS/failure',
  'productsCompare/PRODUCTS_COMPARE_LISTS/cancel',
)<void, CompareLists, Response | Error, void>();
